import React from 'react' ;
import ReactDOM from 'react-dom' ;
import ModalStyle from './Modal.module.css' ;


function BackDrop(props) {
    return <div className={ModalStyle.backdrop} onClick={props.onHideCartHandler}></div>
}


function ModalOverlay(props) {
    return (
        <div className={ModalStyle.modal}>
            <div className={ModalStyle.content}>
                {props.children}
            </div>
        </div>
    )
}




function Modal(props) {

  return (
    <React.Fragment>
        {ReactDOM.createPortal(<BackDrop onHideCartHandler={props.onHideCartHandler}/> , document.getElementById('overlays'))}
        {ReactDOM.createPortal(<ModalOverlay>{props.children}</ModalOverlay> , document.getElementById('overlays'))}
    </React.Fragment>
  )
}

export default Modal ;